// extracted by mini-css-extract-plugin
export default {"cards":"ContactUsCardsSection_cards__n5H+g","cards__card":"ContactUsCardsSection_cards__card__RWmsI"};